import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { QueryFeature } from '../../../config/queryClient';

interface TaxLootsDTO {
  acquiredDate: string;
  sellDate: string;
  costBasis: number;
  longTerm: number;
  proceeds: number;
  shortTerm: number;
  total: number;
  units: number;
}

export interface RealizedGainLossDTO {
  name: string;
  costBasis: number;
  longTerm: number;
  proceeds: number;
  shortTerm: number;
  total: number;
  units: number;
  taxLots: TaxLootsDTO[];
  ticker: string;
}

const fetchRealizedGainLoss = async ({
  clientId,
  accountId,
  groupId,
  period,
  startDate,
  endDate,
}: {
  clientId: string;
  accountId?: string;
  groupId?: string;
  period?: number;
  startDate?: string;
  endDate?: string;
}): Promise<RealizedGainLossDTO[]> =>
  authFetch(
    urlWithParams(
      '/Consumer/OrionAccountsWidgets/RealizedGainLoss',
      {
        clientId,
        accountId: accountId || null,
        groupId: groupId || null,
        period,
        startDate,
        endDate,
      },
      { skipNulls: true },
    ),
  );

export const REALIZED_GAIN_LOSS_QUERY_KEY = 'realizedGainLoss';

export const useRealizedGainLossQuery = ({
  clientId,
  accountId,
  groupId,
  period,
  startDate: _startDate,
  endDate: _endDate,
}: {
  clientId: string;
  accountId?: string;
  groupId?: string;
  period?: number;
  startDate?: string;
  endDate?: string;
}) => {
  const startDate = period === undefined ? _startDate : undefined;
  const endDate = period === undefined ? _endDate : undefined;

  return useQuery(
    [
      QueryFeature.AccountPerformanceReporting,
      REALIZED_GAIN_LOSS_QUERY_KEY,
      clientId,
      accountId,
      groupId,
      period,
      startDate,
      endDate,
    ],

    () => fetchRealizedGainLoss({ clientId, accountId, groupId, period, startDate, endDate }),
  );
};
